import { Input } from "antd";
import { TableProps } from "antd/es/table";
import { useEffect } from "react";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ManageExpenseUnit from "../../../../components/Settings/ExpenseUnit/ManageExpenseUnit";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  useGetExpenseUnitsQuery,
  useUpdateExpenseUnitStatusMutation,
} from "../../../../features/expenseUnit/expenseUnitApi";
import useDebounce from "../../../../hooks/useDebounce";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { ExpenseUnitData } from "../../../../types/expenseUnit";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize } from "../../../../utils/string";
import { addKeyInArray, skipData } from "../../../../utils/utils";
import { SettingStatus } from "../Department/Department";

enum ExpenseUnitStatus {
  "Inactive",
  "Active",
}

export default function ExpenseUnit() {
  const { open, handleClose, handleOpen } = useModal();
  const { keyword, handleInputChange } = useDebounce();
  const { page, limit, handlePagination, handleLimit, resetPagination } =
    useTable();
  const [
    updateExpenseUnitStatus,
    {
      isSuccess: isStatusUpdateSuccess,
      isError: isStatusUpdateError,
      error: statusUpdateError,
    },
  ] = useUpdateExpenseUnitStatusMutation();
  const { isLoading, isError, error, data } = useGetExpenseUnitsQuery({
    params: {
      limit,
      skip: skipData(page, limit),
      ...(keyword ? { search: keyword } : {}),
    },
  });

  useError(isError, error, "Get business unit data fail");
  useError(
    isStatusUpdateError,
    statusUpdateError,
    "Business unit status update fail"
  );

  const columns: TableProps<ExpenseUnitData>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Business Unit Name",
      dataIndex: "name",
      render: (val, record) => (
        <div className="flex items-center gap-2">
          {record?.logo ? (
            <img src={record?.logo} className="w-7 h-7 rounded-full" alt="." />
          ) : null}
          {val}
        </div>
      ),
    },
    // {
    //   title: "Abbreviation",
    //   dataIndex: "abbreviation",
    //   render: (val) => val || "-",
    // },
    {
      title: "Total Employees",
      dataIndex: "employee_count",
      render: (val) => val ?? 0,
    },
    {
      title: "Status",
      dataIndex: "is_published",
      render: (val) => (
        <div className="flex items-center gap-2">
          <span className={SettingStatus[val ? "active" : "inactive"]}>
            {capitalize(val ? "active" : "inactive")}
          </span>
        </div>
      ),
    },
    // {
    //   title: "Action",
    //   width: 200,
    //   render: (val) => (
    //     <Space size={8}>
    //       <Button
    //         className="action-button"
    //         size="small"
    //         icon={<EditIcon />}
    //         onClick={() =>
    //           handleOpen({
    //             type: "UPDATE",
    //             data: val?.id,
    //           })
    //         }
    //       />
    //       <Space size={4}>
    //         <Switch
    //           className="custom-switch"
    //           checked={val?.is_published === 1}
    //           onChange={() =>
    //             updateExpenseUnitStatus({
    //               id: val?.id,
    //               body: {
    //                 is_published: val?.is_published === 0 ? 1 : 0,
    //               },
    //             })
    //           }
    //           // disabled={isStatusUpdateLoading}
    //         />
    //         <span className="text-header text-sm font-medium">
    //           {ExpenseUnitStatus[val?.is_published]}
    //         </span>
    //       </Space>
    //     </Space>
    //   ),
    // },
  ];

  // success toast message
  useEffect(() => {
    if (isStatusUpdateSuccess) {
      toast("success", "Business unit status updated successfully");
    }
  }, [isStatusUpdateSuccess]);

  return (
    <SidebarLayout title="Business Unit List">
      <CustomTable
        loading={isLoading}
        limit={limit}
        page={page}
        columns={columns}
        total={data?.data?.totalLength}
        dataSource={addKeyInArray(data?.data?.expenseUnits)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search by name"
              onChange={(val) => {
                handleInputChange(val);
                resetPagination();
              }}
            />
            {/* <Button
              icon={<AddIcon />}
              type="primary"
              className="sm-button"
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Add Business Unit
            </Button> */}
          </>
        }
      />

      {(open.type === "ADD" || open.type === "UPDATE") && (
        <ManageExpenseUnit
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
    </SidebarLayout>
  );
}
